import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable, Observer, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilityService } from '../../src/app/core/global/utility.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  public currentUrl;
  title = 'my-admin-app-withlogin';
  constructor(private router: Router, private toastr: ToastrService, private _utility: UtilityService) {
    this.router.events.subscribe((res) => {
      
      if (this.router.url.split('/')[1] == 'change-pass') {
        this.currentUrl = '/change-pass'
      }
      else if (this.router.url.split('/')[1] == 'event-details') {
        this.currentUrl = '/event-details'
      }
      else {
        this.currentUrl = this.router.url;
      }
      
    })
  }
  ngOnInit(): void {
    // if (environment.production) {
    //   if (location.protocol === 'http:') {
    //     window.location.href = location.href.replace('http', 'https');
    //   }
    // }
    this.createOnline$().subscribe(isOnline => console.log());
  }
  createOnline$() {
    return merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => this._utility.toasterror("Your Internet Connection is not stable"))),

      fromEvent(window, 'online').pipe(map(() => this._utility.toastSuccess("You Are Back Online"))),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }
}
